import React from 'react'
import { DEFAULTS } from '../../constants/preferences'
import { REGULAR } from '../../userprofile/roles'
import { UserProfile } from '../../userprofile/types/preferences'
import { presettingLeafValues, presettingSoilValues } from '../../pages/Analyses/common/constants'
import { Country, Group, Region, Unit } from '../../graphql/api/types'

const defaultUserProfile: UserProfile = {
  area: {
    name: DEFAULTS.AREA_UNIT,
  } as Unit,
  areaDensity: {
    name: DEFAULTS.AREA_DENSITY_UNIT,
  } as Unit,
  country: {} as Country,
  datePattern: DEFAULTS.DATE_PATTERN,
  density: {
    name: DEFAULTS.DENSITY_UNIT,
  } as Unit,
  email: '',
  group: {} as Group,
  isAdmin: false,
  isAuthorized: false,
  isBlocked: false,
  isOnboarded: false,
  language: DEFAULTS.LANGUAGE,
  length: {
    name: DEFAULTS.LENGTH_UNIT,
  } as Unit,
  name: '',
  permissions: [],
  phone: '',
  region: {} as Region,
  role: REGULAR,
  shouldDisplaySidebarNav: false,
  shouldDisplaySignupRoutes: false,
  userId: '',
  volume: {
    name: DEFAULTS.LENGTH_UNIT,
  } as Unit,
  weight: {
    name: DEFAULTS.WEIGHT_UNIT,
  } as Unit,
  soilAnalysisPresetting: presettingSoilValues,
  leafAnalysisPresetting: presettingLeafValues,
}

const userPreferencesContext = React.createContext<UserProfile>(defaultUserProfile)

userPreferencesContext.displayName = 'UserPreferencesContext'

export { userPreferencesContext as UserPreferencesContext }
